<div class="wrapper-intro" *ngIf="minBudget === maxBudget">
  <div *ngIf="versementRealiste" class="realist-column-container">
    <label class="dsd-t-5">{{ 'capacite.thermometre.titre-court-realiste' | translate }}</label>
    <ng-container *ngTemplateOutlet="realistColumn"></ng-container>
  </div>
  <figure>
    <img src="{{ 'ssets/images/maisons/maison-2.svg' | cheminAbsoluStatique }}" alt="" width="190" height="70" />
  </figure>
  <p class="texte-intro" id="texte-capacite-realiste-only">{{ 'capacite.texte-intro-resultat' | translate }}</p>
</div>

<div class="thermometre-section" *ngIf="minBudget !== maxBudget">
  <div class="mobile-header" *ngIf="!versementRealiste && !versementMaximal">
    <div class="header-col">
      <app-green-label [label]="'general.recommande'"></app-green-label>
      <img src="{{ 'ssets/images/petite-maison.svg' | cheminAbsoluStatique }}" alt="" width="55" height="32" />
    </div>
    <div class="header-col">
      <img src="{{ 'ssets/images/grande-maison.svg' | cheminAbsoluStatique }}" alt="" width="111" height="31" />
    </div>
  </div>

  <div class="flex-container">
    <ng-container *ngIf="versementRealiste && versementMaximal; else minImageBig">
      <img
        class="side-image"
        src="{{ 'ssets/images/petite-maison-120.svg' | cheminAbsoluStatique }}"
        alt=""
        width="81"
        height="45"
      />
    </ng-container>
    <ng-template #minImageBig>
      <img
        class="side-image"
        src="{{ 'ssets/images/petite-maison-120.svg' | cheminAbsoluStatique }}"
        alt=""
        width="120"
        height="67"
      />
    </ng-template>
    <div class="section-content">
      <div class="budget-range top">
        <div class="budget-col range-min">
          <label class="dsd-t-6">{{ 'capacite.thermometre.titre-court-realiste' | translate }}</label>
        </div>
        <div class="budget-col range-max">
          <label class="dsd-t-6">{{ 'capacite.thermometre.titre-court-maximale' | translate }}</label>
        </div>
      </div>
      <div class="thermometre-wrapper">
        <div class="thermometre-line"></div>
      </div>
      <div class="budget-range bottom">
        <div class="budget-col range-min">
          <div class="mark-partial-border"></div>
          <div class="mark"></div>
          <div class="budget-content">
            <ng-container *ngTemplateOutlet="realistColumn"></ng-container>
          </div>
        </div>
        <div class="budget-col range-max">
          <div class="mark-partial-border"></div>
          <div class="mark"></div>
          <div class="budget-content">
            <div class="text">
              <ng-container *ngIf="minBudget && maxBudget && !isThermometreOnly">
                <label id="label-valeur-maison-maximal" class="label-valeur-maison dsd-b-40">{{
                  'capacite.thermometre.label-valeur-maison' | translate
                }}</label>
                <div class="valeur-maison">
                  <app-currency-string [value]="maxBudget" [id]="'valeur-maximale'"></app-currency-string>
                </div>
              </ng-container>
              <ng-container *ngIf="versementRealiste && versementMaximal && !isThermometreOnly">
                <label id="label-versement-mensuel-maximal" class="label-versement-mensuel dsd-b-40">
                  {{ 'dashboard.active-capacite.label-versement-mensuel' | translate }}
                </label>
                <div class="versement-mensuel">
                  <app-currency-string
                    [value]="versementMaximal"
                    [periodicity]="'general.par-mois' | translate"
                    [id]="'mensualite-maximale'"
                  ></app-currency-string>
                </div>
                <div class="versement-mensuel-plus-frais dsd-b-40">
                  <app-currency-string
                    class="versement-mensuel-plus-frais-montant dsd-b-40"
                    [value]="versementMaximal + fraisPropriete"
                    [periodicity]="'general.par-mois' | translate"
                    [id]="'mensualite-maximale-plus-frais'"
                  >
                  </app-currency-string>
                  <span class="incluant-frais">{{
                    'dashboard.active-capacite.incluant-frais-moyens' | translate
                  }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="versementRealiste && versementMaximal; else maxImageBig">
      <img
        class="side-image"
        src="{{ 'ssets/images/grande-maison-240.svg' | cheminAbsoluStatique }}"
        alt=""
        width="161"
        height="45"
      />
    </ng-container>
    <ng-template #maxImageBig>
      <img
        class="side-image"
        src="{{ 'ssets/images/grande-maison-240.svg' | cheminAbsoluStatique }}"
        alt=""
        width="240"
        height="67"
      />
    </ng-template>
  </div>
</div>

<ng-template #realistColumn>
  <div class="text">
    <ng-container *ngIf="minBudget && maxBudget && !isThermometreOnly">
      <label id="label-valeur-maison-realiste" class="label-valeur-maison dsd-b-40">{{
        'capacite.thermometre.label-valeur-maison' | translate
      }}</label>
      <div class="valeur-maison">
        <app-currency-string [value]="minBudget" id="valeur-realiste"></app-currency-string>
      </div>
    </ng-container>
    <ng-container *ngIf="versementRealiste && versementMaximal && !isThermometreOnly">
      <label class="label-versement-mensuel dsd-b-40" id="label-versement-mensuel-realiste">
        {{ 'dashboard.active-capacite.label-versement-mensuel' | translate }}
      </label>
      <div class="versement-mensuel">
        <app-currency-string
          [value]="versementRealiste"
          [periodicity]="'general.par-mois' | translate"
          [id]="'mensualite-realiste'"
        ></app-currency-string>
      </div>
      <div class="versement-mensuel-plus-frais dsd-b-40">
        <app-currency-string
          class="versement-mensuel-plus-frais-montant"
          [value]="versementRealiste + fraisPropriete"
          [periodicity]="'general.par-mois' | translate"
          [id]="'mensualite-realiste-plus-frais'"
        >
        </app-currency-string>
        <span class="incluant-frais">{{ 'dashboard.active-capacite.incluant-frais-moyens' | translate }}</span>
      </div>
    </ng-container>
  </div>
</ng-template>
